export default "__VITE_ASSET__Dt1ZjhHr__"